import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import slick from 'slick-carousel';
import './twentytwenty/jquery.event.move';
import './twentytwenty/jquery.twentytwenty';

function scrollHandler() {
	const scrollPos = $(document).scrollTop();
	const $interview = $('.interview');
	const $nav = $('.nav');
	const width = $(window).innerWidth();

	if (width > 720) {
		if (scrollPos + ($nav.width() / 2) < $interview.offset().top) {
			$nav.removeClass('nav_fixed');
			$nav.removeClass('nav_bottom');
			$nav.addClass('nav_top');
			$nav.css({
				position: 'absolute',
				top: $nav.width() / 2,
				bottom: 'auto'
			});
		}
		if (scrollPos + ($nav.width() / 2) >= $interview.offset().top) {
			$nav.removeClass('nav_top');
			$nav.removeClass('nav_bottom');
			$nav.addClass('nav_fixed');
			$nav.css({
				position: 'fixed',
				top: 'auto',
				bottom: $nav.width() / 2
			});
		}
		if (scrollPos > $interview.height() + $(window).height()) {
			$nav.removeClass('nav_fixed');
			$nav.removeClass('nav_top');
			$nav.addClass('nav_bottom');
			$nav.css({
				position: 'absolute',
				top: 'auto',
				bottom: $nav.width() / 2
			});
		}
	}
}

function openStory(e) {
	const $story = $(e.target).closest('.story');
	$story.addClass('is-active');
}

$(() => {
	const $shareSlider = $('.share-slider');
	const $baSlider = $('.ba-slider__slides');
	svg4everybody();


	$shareSlider.slick({
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear'
	});

	$shareSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$('.contest__share').removeClass(`slide-${currentSlide}`);
		$('.contest__share').addClass(`slide-${nextSlide}`);
	});

	$('.js-contest').on('click', function (e) {
		e.preventDefault();
		if ($(window).width() > 720) {
			$('.contest__auth').animate({
				opacity: 0
			}, 500, function () {
				$('.contest__auth').animate({
					opacity: 1
				}, 500);
			});
		}
		else {
			$('html, body').animate({
				scrollTop: $('.contest__auth').offset().top
			}, 500);
		}
	});

	$('.story').on('click', (e) => openStory(e));

	$(window).on('load scroll resize', scrollHandler);

	$('.nav__link').on('click', e => {
		e.preventDefault();
		const $target = $(e.target).data('href');

		if (!$target) { return; }

		$('html, body').animate({
			scrollTop: $(`.${$target}`).offset().top
		}, 500);

		if ($('body').hasClass('show-menu')) {
			$('body').removeClass('show-menu');
		}
	});

	$baSlider.each((i, slide) => {
		$(slide).slick({
			fade: true,
			cssEase: 'linear',
			draggable: false,
			swipe: false,
			touchMove: false,
			arrows: false,
			dots: true,
			customPaging: (slider, index) => {
				const title = $(slider.$slides[index]).find('.ba-slider__slide').data('title');
				return '<span>' + title + '</span>';
			}
		});
	});

	$('.summary__slider').each((i, slide) => {
		$(slide).slick({
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000
		});
	});

	$('.before-after').each((i, image) => {
		$(image).twentytwenty({
			before_label: 'До',
			after_label: 'После'
		});
	});

	$('.header__nav').on('click', function() {
		const show = 'show-menu';
		if ($('body').hasClass(show)) {
			$('body').removeClass(show);
		} else {
			$('body').addClass(show);
		}
	});

	$('.header__link').on('click', '.btn', function (e) {
		e.preventDefault();

		$('html, body').animate({
			scrollTop: $('.contest').offset().top
		}, 500);
	});

	$('.popup').on('click', '.popup__close', function () {
		const show = 'show-popup';
		if ($('body').hasClass(show)) {
			$('body').removeClass(show);
		}
	});

	$('.popup').on('click', '.js-readstory', function () {
		$('body').removeClass('show-popup');
		$('html, body').animate({
			scrollTop: $('.interview').offset().top
		}, 500);
	});

	$('.contest__share').on('click', '.socials__link', function (e) {
		e.preventDefault();
		const link = $(e.target).closest('.socials__link');
		console.log(link);
		$('body').addClass('show-popup');
	});

	$('.overlay').on('click', function() {
		$('body').removeClass('show-popup');
		$('body').removeClass('show-menu');
	})
});



// WEBPACK FOOTER //
// ./app/scripts/app.js